import { render, staticRenderFns } from "./AdPolicyCard.vue?vue&type=template&id=48e89d95&scoped=true&"
import script from "./AdPolicyCard.vue?vue&type=script&lang=js&"
export * from "./AdPolicyCard.vue?vue&type=script&lang=js&"
import style0 from "./AdPolicyCard.vue?vue&type=style&index=0&id=48e89d95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e89d95",
  null
  
)

export default component.exports